import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, unref as _unref, vShow as _vShow, withDirectives as _withDirectives, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "text-h3 font-weight-bold mb-6"
}
const _hoisted_2 = {
  key: 1,
  class: "text-h3 font-weight-bold mb-6"
}
const _hoisted_3 = { class: "font-weight-bold text-h5 text-blue-grey-darken-4 py-3" }
const _hoisted_4 = { class: "font-weight-bold text-h5 text-blue-grey-darken-4 py-3" }
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { class: "font-weight-bold text-h5 text-blue-grey-darken-4 py-3" }
const _hoisted_7 = { class: "text-h5 text-blue-grey-darken-4 font-weight-bold" }
const _hoisted_8 = {
  key: 0,
  width: "250",
  class: "text-right"
}
const _hoisted_9 = { class: "text-right" }
const _hoisted_10 = { key: 0 }
const _hoisted_11 = {
  key: 0,
  class: "mb-4"
}
const _hoisted_12 = {
  key: 1,
  class: "mb-4"
}
const _hoisted_13 = { key: 0 }
const _hoisted_14 = {
  key: 0,
  class: "mb-4 text-red-lighten-1"
}
const _hoisted_15 = {
  key: 0,
  class: "text-h6 font-weight-semibold mb-4 ml-8"
}
const _hoisted_16 = { key: 0 }
const _hoisted_17 = { key: 1 }
const _hoisted_18 = {
  key: 0,
  class: "text-h6 font-weight-semibold mb-4"
}

import { ref, computed } from 'vue';
import { injectStrict, CurrencyJSKey, CircularLoaderKey, SnackbarKey, AxiosKey } from '@/symbols';
import { useCartStore } from '@/stores/cart';
import { useUserStore } from '@/stores/user';
import { Rules } from '@/rules';
import { getCreditCardType } from '@/util/creditCardType';
import { useDisplay } from 'vuetify';
import { useRouter } from 'vue-router';
import { AxiosResponse, AxiosError } from 'axios';
import states from 'states-us';


export default /*@__PURE__*/_defineComponent({
  __name: 'CheckoutPage',
  setup(__props) {

/*global Server*/
const Currency = injectStrict(CurrencyJSKey);
const CircularLoader = injectStrict(CircularLoaderKey);
const Snackbar = injectStrict(SnackbarKey);
const router = useRouter();
const cartStore = useCartStore();
const userStore = useUserStore();
const { mobile, smAndDown } = useDisplay();
const http = injectStrict(AxiosKey);

const isLoading = CircularLoader.isOpen;
const isFormValid = ref(true)
const checkoutForm = ref();
const isProcessing = ref(false);
const convenienceFeePercentage = ref(2.49);


const isUserLoggedIn = computed(() => {
  return userStore.user != null && Object.keys(userStore.user).length > 0
});

const isCheckoutBtnDisabled = computed(() => {
  return !isFormValid.value || isProcessing.value || purchaseForm.value.PaymentMethods.length === 0;
});


const purchaseForm = ref<Server.IPaymentForm>({
  PhoneNumber: userStore.user?.PhoneNumber || '',
  EmailAddress: userStore.user?.EmailAddress || '',
  Purchases: cartStore.getAsPurchases,
  PaymentMethods: [],
});


// #region Payment Method Form Logic

const showPaymentFormDialog = ref(false);
const isPaymentFormDialogEdit = ref(false);
const isPaymentFormValid = ref(false);
const paymentMethodForm = ref();
const currentPaymentMethodForm = ref<Server.ICheckingAccountPayment & Server.ICreditCardPayment>({
  $type: '',
  ID: 0,
  PaymentType: 'ACH', // Default to ACH
  FirstName: '',
  LastName: '',
  StreetAddress: '',
  City: '',
  State: '',
  Zip: '',
  // Credit Card fields (always present for type safety)
  CreditCardHolder: '',
  CreditCardNumber: '',
  CreditCardExp: '',
  CreditCardCVV: '',
  // ACH fields (always present for type safety)
  BankRoutingNumber: '',
  BankAccountNumber: '',
  Nickname: '',
});


function showPaymentMethodForm() {
  isPaymentFormDialogEdit.value = false;
  currentPaymentMethodForm.value = {
    $type: '',
    ID: Math.max(0, ...purchaseForm.value.PaymentMethods.map(m => m.ID)) + 1,
    PaymentType: 'ACH', // Default to ACH
    FirstName: '',
    LastName: '',
    StreetAddress: '',
    City: '',
    State: '',
    Zip: '',
    // Credit Card fields (always present for type safety)
    CreditCardHolder: '',
    CreditCardNumber: '',
    CreditCardExp: '',
    CreditCardCVV: '',
    // ACH fields (always present for type safety)
    BankRoutingNumber: '',
    BankAccountNumber: '',
    Nickname: '',
  };
  paymentMethodForm.value?.resetValidation();
  showPaymentFormDialog.value = true;
}

function showEditPaymentMethodForm(paymentMethod: Server.ICheckingAccountPayment & Server.ICreditCardPayment) {
  isPaymentFormDialogEdit.value = true;
  currentPaymentMethodForm.value = paymentMethod;
  paymentMethodForm.value?.resetValidation();
  showPaymentFormDialog.value = true;
}


function addPaymentMethod() {
  if (isPaymentFormValid.value) {

    //Need to set payment type to metadeta field so it gets serialized correctly.
    currentPaymentMethodForm.value.$type = currentPaymentMethodForm.value.PaymentType == "CC" ? 'CreditCardPayment' : 'CheckingAccountPayment';
    if (isPaymentFormDialogEdit.value) {
      const index = purchaseForm.value.PaymentMethods.findIndex(m => m.ID === currentPaymentMethodForm.value.ID);
      if (index !== -1) {
        purchaseForm.value.PaymentMethods[index] = currentPaymentMethodForm.value;
      }
    } else {
      purchaseForm.value.PaymentMethods.push(currentPaymentMethodForm.value);
    }

    showPaymentFormDialog.value = false;
    paymentMethodForm.value?.resetValidation();

  } else {
    paymentMethodForm.value?.validate();
  }
}


function removePaymentMethod(id: number) {
  const index = purchaseForm.value.PaymentMethods.findIndex(m => m.ID === id);
  if (index !== -1) {
    purchaseForm.value.PaymentMethods.splice(index, 1);

    //Set any purshases that were using this payment method to the first payment method.
    purchaseForm.value.Purchases.forEach(p => {
      if (p.PaymentMethodID === id) {
        p.PaymentMethodID = purchaseForm.value.PaymentMethods[0] ? purchaseForm.value.PaymentMethods[0].ID : 1;
      }
    });
  }
}

// #endregion

// #region Order Summary Calculations

const citationsTotal = computed(() => {
  return cartStore.citations.reduce((total, item) => total + (item.Overview.AmountToPay || 0), 0);
});

const convenienceFeeTotal = computed(() => {
  // Calculate convenience fee based on payment methods and their associated purchases
  let totalFee = 0;

  purchaseForm.value.PaymentMethods.forEach(method => {
    if (method.PaymentType === 'CC') {
      // Sum up the amounts for purchases using this credit card
      const methodPurchases = purchaseForm.value.Purchases.filter(p => p.PaymentMethodID === method.ID);
      const methodTotal = methodPurchases.reduce((sum, p) => sum + (p.AmountToPay || 0), 0);
      totalFee += (methodTotal * convenienceFeePercentage.value) / 100;
    }
  });

  return totalFee;
});

const orderTotal = computed(() => {
  return citationsTotal.value + convenienceFeeTotal.value;
});

//#endregion

// #region Purchases Grouping

//This groups the property taxes and tax certificates by BillNumber and TaxYear to display on the left side of the cart.
const groupedPurchases = computed<Record<string, { info: Server.ICitationSearchResult, purchases: Server.ICitationPurchase[] }>>(() => {
  const groups: Record<string, { info: Server.ICitationSearchResult, purchases: Server.ICitationPurchase[] }> = {};
  cartStore.citations.forEach(item => {
    const key = "C_" + item.Overview.InquiryID;
    // Start group with the first item from propertyTaxes
    if (!groups[key]) {
      groups[key] = { info: item, purchases: [] };
    }
  });

  // Add remaining items from GetAspurchases
  cartStore.getAsPurchases.forEach(item => {
    const key = "C_" + item.InquiryID;
    if (groups[key]) {
      groups[key].purchases.push(item);
    }
  });

  return groups;
});

// #endregion

// #region Payment Method Select Logic

const isPaymentMethodSelectVisible = computed(() => {
  return purchaseForm.value.PaymentMethods.length > 1;
});
//need this because the groupedPurchases is a computed and we can't directly bind to it in the form.
function getPurchaseItem(item: Server.ICitationPurchase) {
  return purchaseForm.value.Purchases.find(p => p.InquiryID === item.InquiryID);
}

function setPaymentMethodForPurchase(purchase: Server.ICitationPurchase, paymentMethodID: number) {
  const item = getPurchaseItem(purchase);
  if (item) {
    item.PaymentMethodID = paymentMethodID;
  }
}

const paymentMethodDropdowns = computed(() => {
  return purchaseForm.value.PaymentMethods.map(method => {
    return {
      text: method.Nickname ? method.Nickname : (method.PaymentType === 'CC' ? maskDetails(method.CreditCardNumber) : maskDetails(method.BankAccountNumber)),
      value: method.ID,
      raw: method
    };
  });
});

function maskDetails(inputString: string): string {
  // Replace all but the last 4 characters with '*'
  if (inputString.length <= 4) {
    return inputString; // No masking needed
  }
  const lastFour = inputString.slice(-4);
  return lastFour.padStart(inputString.length, '*');
}

function getCCType(cardNumber: string): string | null {
  const cardType = getCreditCardType(cardNumber);
  if (cardType) {
    return cardType.charAt(0).toUpperCase() + cardType.slice(1); // Capitalize first letter
  }
  return cardType;
}
// #endregion

// #region Text Formatting Functions

function formatCurrency(amount?: number | string | undefined): string {
  if (amount != null && amount != '' && amount != undefined) {
    return Currency(amount).format();
  }
  return '$0.00';
}

// #endregion


function getConvenienceFee() {
  isLoading.value = true;
  http.get('/payment/GetConvenienceFee').then((response: AxiosResponse<number>) => {
    if (response && response.data) {
      convenienceFeePercentage.value = response.data;
    }
  }).finally(() => {
    isLoading.value = false;
  });
}


const confirmBankAccount = (confirmValue: string, orgValue: string): string | boolean => confirmValue === orgValue || "Account numbers must match";


const expandContactCard = ref(true);
const expandPaymentCard = ref(true);
const expandAssignPaymentsCard = ref(true);

function checkout() {
  if (isFormValid.value && purchaseForm.value.PaymentMethods.length > 0) {
    isProcessing.value = true;
    http.post('/payment/checkout', purchaseForm.value).then((response: AxiosResponse<Server.ICheckoutReturnModel>) => {
      if ((response.status == 200 || response.status == 204) && response.data !== null
        && (response.data.ConfirmationNumber !== "" && response.data.ConfirmationNumber != undefined)
        && (response.data.HashedReceiptConfirmation !== "" && response.data.HashedReceiptConfirmation != undefined)
        && response.data.ErrorMessage == undefined) {

        cartStore.clearCart();
        cartStore.clearCheckoutTimer();

        router.push(`/payment-confirmation?confirmationNumber=${response.data.ConfirmationNumber}&token=${response.data.HashedReceiptConfirmation}`);
      } else {
        isProcessing.value = false;
        Snackbar.open(response.data.ErrorMessage || "An error occurred while processing your payment. Please try again later.", 5000, 'error');
      }

    }).catch((error: AxiosError<Server.ICheckoutReturnModel>) => {
      Snackbar.open(error.response?.data?.ErrorMessage || "An error occurred while processing your payment. Please try again later.", 5000, 'error');
    }).finally(() => {
      isProcessing.value = false;
    });

  } else {
    checkoutForm.value?.validate();
  }
}

function checkIfCartIsEmpty() {
  if ((cartStore.citations.length === 0) || orderTotal.value <= 0) {
    router.push('/cart');
  }
}

function displayCourtName(item: Server.ICitationSearchResult): string {
  if (item.Overview.Court == 'F') {
    return '1st Parish Court';
  } else if (item.Overview.Court == 'S') {
    return '2nd Parish Court';
  }
  return '';
}


checkIfCartIsEmpty();
getConvenienceFee();


return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_card_item = _resolveComponent("v-card-item")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_mask_input = _resolveComponent("v-mask-input")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_expand_transition = _resolveComponent("v-expand-transition")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_empty_state = _resolveComponent("v-empty-state")!
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_list_item_subtitle = _resolveComponent("v-list-item-subtitle")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_alert = _resolveComponent("v-alert")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_table = _resolveComponent("v-table")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_form = _resolveComponent("v-form")!
  const _component_v_card_subtitle = _resolveComponent("v-card-subtitle")!
  const _component_v_radio = _resolveComponent("v-radio")!
  const _component_v_radio_group = _resolveComponent("v-radio-group")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_dialog = _resolveComponent("v-dialog")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createBlock(_component_v_container, { class: "pa-6" }, {
    default: _withCtx(() => [
      (isUserLoggedIn.value)
        ? (_openBlock(), _createElementBlock("h1", _hoisted_1, "Checkout"))
        : (_openBlock(), _createElementBlock("h1", _hoisted_2, "Guest Checkout")),
      _createVNode(_component_v_form, {
        ref_key: "checkoutForm",
        ref: checkoutForm,
        modelValue: isFormValid.value,
        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((isFormValid).value = $event)),
        onSubmit: _withModifiers(checkout, ["prevent"])
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_row, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_col, {
                cols: "12",
                lg: "9"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_card, {
                    elevation: "4",
                    rounded: "lg",
                    class: "mb-6"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_card_item, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_card_title, {
                            onClick: _cache[0] || (_cache[0] = ($event: any) => (expandContactCard.value = !expandContactCard.value))
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("h2", _hoisted_3, [
                                _cache[24] || (_cache[24] = _createTextVNode("Contact Information ", -1)),
                                _createVNode(_component_v_icon, {
                                  icon: expandContactCard.value ? 'mdi-chevron-up' : 'mdi-chevron-down',
                                  class: "float-right text-blue-grey-darken-4"
                                }, null, 8, ["icon"])
                              ])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_expand_transition, null, {
                        default: _withCtx(() => [
                          _withDirectives(_createElementVNode("div", null, [
                            _createVNode(_component_v_card_text, null, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_text_field, {
                                  modelValue: purchaseForm.value.EmailAddress,
                                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((purchaseForm.value.EmailAddress) = $event)),
                                  label: "Email address",
                                  maxlength: "50",
                                  variant: "outlined",
                                  density: "comfortable",
                                  class: "mb-2",
                                  rules: [_unref(Rules).required, ..._unref(Rules).email]
                                }, null, 8, ["modelValue", "rules"]),
                                _createVNode(_component_v_mask_input, {
                                  modelValue: purchaseForm.value.PhoneNumber,
                                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((purchaseForm.value.PhoneNumber) = $event)),
                                  label: "Phone number",
                                  mask: "phone",
                                  variant: "outlined",
                                  density: "comfortable",
                                  class: "mb-2",
                                  rules: [_unref(Rules).required]
                                }, null, 8, ["modelValue", "rules"])
                              ]),
                              _: 1
                            })
                          ], 512), [
                            [_vShow, expandContactCard.value]
                          ])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_card, {
                    elevation: "4",
                    rounded: "lg",
                    class: "mb-6"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_card_item, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_card_title, {
                            onClick: _cache[3] || (_cache[3] = ($event: any) => (expandPaymentCard.value = !expandPaymentCard.value))
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("h2", _hoisted_4, [
                                _cache[25] || (_cache[25] = _createTextVNode("Payment method ", -1)),
                                _createVNode(_component_v_icon, {
                                  icon: expandPaymentCard.value ? 'mdi-chevron-up' : 'mdi-chevron-down',
                                  class: "float-right text-blue-grey-darken-4"
                                }, null, 8, ["icon"])
                              ])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_expand_transition, null, {
                        default: _withCtx(() => [
                          _withDirectives(_createElementVNode("div", null, [
                            _createVNode(_component_v_card_text, null, {
                              default: _withCtx(() => [
                                (purchaseForm.value.PaymentMethods.length === 0)
                                  ? (_openBlock(), _createBlock(_component_v_empty_state, {
                                      key: 0,
                                      class: "border-sm",
                                      color: "grey-lighten-4",
                                      title: "No payment method selected",
                                      "action-text": "ADD PAYMENT METHOD",
                                      "onClick:action": showPaymentMethodForm
                                    }, {
                                      media: _withCtx(() => [
                                        _createVNode(_component_v_icon, {
                                          size: "x-large",
                                          color: "grey-darken-1"
                                        }, {
                                          default: _withCtx(() => [...(_cache[26] || (_cache[26] = [
                                            _createTextVNode("mdi-credit-card-outline", -1)
                                          ]))]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    }))
                                  : (_openBlock(), _createElementBlock("div", _hoisted_5, [
                                      _createVNode(_component_v_list, { lines: "two" }, {
                                        default: _withCtx(() => [
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(purchaseForm.value.PaymentMethods, (paymentMethod) => {
                                            return (_openBlock(), _createBlock(_component_v_list_item, {
                                              key: paymentMethod.ID,
                                              rounded: "lg",
                                              class: _normalizeClass({ 'border-sm': true, ' mb-4': true, 'd-flex': _unref(smAndDown), 'flex-column': _unref(smAndDown) })
                                            }, {
                                              prepend: _withCtx(() => [
                                                _createVNode(_component_v_icon, {
                                                  icon: paymentMethod.PaymentType === 'CC' ? 'mdi-credit-card-outline' : 'mdi-bank-outline',
                                                  color: "black"
                                                }, null, 8, ["icon"])
                                              ]),
                                              append: _withCtx(() => [
                                                _createVNode(_component_v_btn, {
                                                  "prepend-icon": "mdi-square-edit-outline",
                                                  size: "x-large",
                                                  variant: "text",
                                                  color: "blue-darken-2",
                                                  onClick: ($event: any) => (showEditPaymentMethodForm(paymentMethod)),
                                                  "aria-label": "Edit Payment Method"
                                                }, {
                                                  default: _withCtx(() => [...(_cache[27] || (_cache[27] = [
                                                    _createTextVNode("Edit", -1)
                                                  ]))]),
                                                  _: 1
                                                }, 8, ["onClick"]),
                                                _createVNode(_component_v_btn, {
                                                  icon: "mdi-trash-can-outline",
                                                  size: "x-large",
                                                  variant: "text",
                                                  color: "red-accent-2",
                                                  onClick: ($event: any) => (removePaymentMethod(paymentMethod.ID)),
                                                  "aria-label": "Remove Payment Method"
                                                }, null, 8, ["onClick"])
                                              ]),
                                              default: _withCtx(() => [
                                                _createVNode(_component_v_list_item_title, { class: "font-weight-bold" }, {
                                                  default: _withCtx(() => [
                                                    _createTextVNode(_toDisplayString(paymentMethod.Nickname ? paymentMethod.Nickname : (paymentMethod.PaymentType === 'CC' ?
                            'Card ending in ' + paymentMethod.CreditCardNumber.slice(-4) :
                            'Account ending in ' + paymentMethod.BankAccountNumber.slice(-4))), 1)
                                                  ]),
                                                  _: 2
                                                }, 1024),
                                                _createVNode(_component_v_list_item_subtitle, null, {
                                                  default: _withCtx(() => [
                                                    _createTextVNode(_toDisplayString(paymentMethod.PaymentType === 'CC' ? `${getCCType(paymentMethod.CreditCardNumber)}
                          ${maskDetails(paymentMethod.CreditCardNumber)}` :
                            `Bank Account ${maskDetails(paymentMethod.BankAccountNumber)}`), 1)
                                                  ]),
                                                  _: 2
                                                }, 1024)
                                              ]),
                                              _: 2
                                            }, 1032, ["class"]))
                                          }), 128))
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_v_btn, {
                                        color: "grey-lighten-2",
                                        variant: "flat",
                                        block: _unref(smAndDown),
                                        onClick: showPaymentMethodForm
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(purchaseForm.value.PaymentMethods.length === 0 ? 'Add Payment Method' : 'Add Another Payment Method'), 1)
                                        ]),
                                        _: 1
                                      }, 8, ["block"]),
                                      (purchaseForm.value.PaymentMethods.length > 1)
                                        ? (_openBlock(), _createBlock(_component_v_alert, {
                                            key: 0,
                                            type: "info",
                                            variant: "tonal",
                                            icon: "mdi-information-outline",
                                            class: "mt-6"
                                          }, {
                                            default: _withCtx(() => [...(_cache[28] || (_cache[28] = [
                                              _createElementVNode("span", { class: "text-blue-grey-darken-1" }, " Assign payment methods to the items in the section below. ", -1)
                                            ]))]),
                                            _: 1
                                          }))
                                        : _createCommentVNode("", true)
                                    ]))
                              ]),
                              _: 1
                            })
                          ], 512), [
                            [_vShow, expandPaymentCard.value]
                          ])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  (purchaseForm.value.PaymentMethods.length > 1)
                    ? (_openBlock(), _createBlock(_component_v_card, {
                        key: 0,
                        elevation: "4",
                        rounded: "lg",
                        class: "mb-6"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_card_item, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_card_title, {
                                onClick: _cache[4] || (_cache[4] = ($event: any) => (expandAssignPaymentsCard.value = !expandAssignPaymentsCard.value))
                              }, {
                                default: _withCtx(() => [
                                  _createElementVNode("h2", _hoisted_6, [
                                    _cache[29] || (_cache[29] = _createTextVNode("Assign payments ", -1)),
                                    _createVNode(_component_v_icon, {
                                      icon: expandAssignPaymentsCard.value ? 'mdi-chevron-up' : 'mdi-chevron-down',
                                      class: "float-right text-blue-grey-darken-4"
                                    }, null, 8, ["icon"])
                                  ])
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_v_expand_transition, null, {
                            default: _withCtx(() => [
                              _withDirectives(_createElementVNode("div", null, [
                                _createVNode(_component_v_card_text, null, {
                                  default: _withCtx(() => [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(groupedPurchases.value, (groupedItem, key) => {
                                      return (_openBlock(), _createBlock(_component_v_card, {
                                        key: key,
                                        class: "pa-4 pa-sm-6 mb-5 border-sm",
                                        color: "white",
                                        elevation: "0",
                                        rounded: "lg"
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_row, { align: "center" }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_v_col, {
                                                cols: "12",
                                                sm: "5"
                                              }, {
                                                default: _withCtx(() => [
                                                  _createElementVNode("h3", _hoisted_7, _toDisplayString(groupedItem.info.Overview.Court + groupedItem.info.Overview.CaseNo), 1)
                                                ]),
                                                _: 2
                                              }, 1024),
                                              _createVNode(_component_v_col, {
                                                cols: "12",
                                                sm: "4",
                                                class: "d-flex justify-sm-end"
                                              }, {
                                                default: _withCtx(() => [...(_cache[30] || (_cache[30] = [
                                                  _createElementVNode("div", { class: "d-flex flex-column align-end" }, null, -1)
                                                ]))]),
                                                _: 1
                                              })
                                            ]),
                                            _: 2
                                          }, 1024),
                                          _createVNode(_component_v_row, {
                                            align: "center",
                                            class: "mt-0"
                                          }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_v_col, { cols: "12" }, {
                                                default: _withCtx(() => [
                                                  _createVNode(_component_v_table, { class: "responsive-table" }, {
                                                    default: _withCtx(() => [
                                                      _createElementVNode("thead", null, [
                                                        _createElementVNode("tr", null, [
                                                          _cache[31] || (_cache[31] = _createElementVNode("th", null, "Name", -1)),
                                                          _cache[32] || (_cache[32] = _createElementVNode("th", null, "Case", -1)),
                                                          _cache[33] || (_cache[33] = _createElementVNode("th", null, "Issuing Agency", -1)),
                                                          _cache[34] || (_cache[34] = _createElementVNode("th", { class: "text-right" }, "Amount To Pay", -1)),
                                                          (isPaymentMethodSelectVisible.value)
                                                            ? (_openBlock(), _createElementBlock("th", _hoisted_8, "Payment Method"))
                                                            : _createCommentVNode("", true)
                                                        ])
                                                      ]),
                                                      _createElementVNode("tbody", null, [
                                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(groupedItem.purchases, (tran) => {
                                                          return (_openBlock(), _createElementBlock("tr", {
                                                            key: tran.InquiryID
                                                          }, [
                                                            _createElementVNode("td", null, _toDisplayString((groupedItem.info.Overview.LastNameFromSearch || '') +
                                (groupedItem.info.Overview.FirstNameFromSearch || '') + (groupedItem.info.Overview.MI ||
                                  '')), 1),
                                                            _createElementVNode("td", null, _toDisplayString(groupedItem.info.Overview.CaseNo), 1),
                                                            _createElementVNode("td", null, _toDisplayString(displayCourtName(groupedItem.info)), 1),
                                                            _createElementVNode("td", _hoisted_9, _toDisplayString(formatCurrency(tran.AmountToPay)), 1),
                                                            (isPaymentMethodSelectVisible.value)
                                                              ? (_openBlock(), _createElementBlock("td", _hoisted_10, [
                                                                  _createVNode(_component_v_select, {
                                                                    "model-value": getPurchaseItem(tran)?.PaymentMethodID,
                                                                    "onUpdate:modelValue": (value) => setPaymentMethodForPurchase(tran, value),
                                                                    items: paymentMethodDropdowns.value,
                                                                    "item-title": "text",
                                                                    "item-value": "value",
                                                                    class: "mt-5",
                                                                    variant: "outlined",
                                                                    density: "compact"
                                                                  }, null, 8, ["model-value", "onUpdate:modelValue", "items"])
                                                                ]))
                                                              : _createCommentVNode("", true)
                                                          ]))
                                                        }), 128))
                                                      ])
                                                    ]),
                                                    _: 2
                                                  }, 1024)
                                                ]),
                                                _: 2
                                              }, 1024)
                                            ]),
                                            _: 2
                                          }, 1024)
                                        ]),
                                        _: 2
                                      }, 1024))
                                    }), 128))
                                  ]),
                                  _: 1
                                })
                              ], 512), [
                                [_vShow, expandAssignPaymentsCard.value]
                              ])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }),
              _createVNode(_component_v_col, {
                cols: "12",
                lg: "3"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_card, {
                    class: "pa-5 summary-card",
                    color: "white",
                    elevation: "4",
                    rounded: "lg"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_card_title, { class: "text-h5 font-weight-semibold pa-0 mb-4" }, {
                        default: _withCtx(() => [...(_cache[35] || (_cache[35] = [
                          _createTextVNode("Order Summary", -1)
                        ]))]),
                        _: 1
                      }),
                      (_unref(cartStore).citations.length > 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                            _createVNode(_component_v_row, {
                              dense: "",
                              class: "mb-2 text-subtitle-1"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_col, null, {
                                  default: _withCtx(() => [...(_cache[36] || (_cache[36] = [
                                    _createTextVNode("Cases", -1)
                                  ]))]),
                                  _: 1
                                }),
                                _createVNode(_component_v_col, { class: "text-right font-weight-medium" }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(formatCurrency(citationsTotal.value)), 1)
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ]))
                        : _createCommentVNode("", true),
                      (convenienceFeeTotal.value > 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                            _createVNode(_component_v_row, {
                              dense: "",
                              class: "mb-2 text-subtitle-1"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_col, null, {
                                  default: _withCtx(() => [...(_cache[37] || (_cache[37] = [
                                    _createTextVNode("Convenience Fee", -1)
                                  ]))]),
                                  _: 1
                                }),
                                _createVNode(_component_v_col, { class: "text-right font-weight-medium" }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(formatCurrency(convenienceFeeTotal.value)), 1)
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ]))
                        : _createCommentVNode("", true),
                      _createVNode(_component_v_divider, {
                        class: "mb-4",
                        color: "grey-darken-2"
                      }),
                      _createVNode(_component_v_row, {
                        dense: "",
                        class: "font-weight-bold mb-6"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_col, { class: "text-h6" }, {
                            default: _withCtx(() => [...(_cache[38] || (_cache[38] = [
                              _createTextVNode("Order Total", -1)
                            ]))]),
                            _: 1
                          }),
                          _createVNode(_component_v_col, { class: "text-right text-h6" }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(formatCurrency(orderTotal.value)), 1)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_btn, {
                        type: "submit",
                        color: "blue-darken-2",
                        size: "large",
                        block: "",
                        loading: isProcessing.value,
                        disabled: isCheckoutBtnDisabled.value,
                        class: "mt-4 text-white font-weight-bold",
                        elevation: "4"
                      }, {
                        default: _withCtx(() => [
                          (!isProcessing.value)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_13, "PAY NOW"))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      }, 8, ["loading", "disabled"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _createVNode(_component_v_dialog, {
        "max-width": "1000",
        persistent: "",
        modelValue: showPaymentFormDialog.value,
        "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((showPaymentFormDialog).value = $event))
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_card, {
            class: "pa-4 position-relative",
            elevation: "4",
            rounded: "lg"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_form, {
                ref_key: "paymentMethodForm",
                ref: paymentMethodForm,
                modelValue: isPaymentFormValid.value,
                "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((isPaymentFormValid).value = $event)),
                onSubmit: _withModifiers(addPaymentMethod, ["prevent"])
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_card_title, { class: "font-weight-bold" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(isPaymentFormDialogEdit.value ? 'Edit Payment Method' : 'Add Payment Method') + " ", 1),
                      _createVNode(_component_v_btn, {
                        class: "position-absolute top-0 right-0",
                        icon: "mdi-close",
                        variant: "text",
                        onClick: _cache[6] || (_cache[6] = ($event: any) => (showPaymentFormDialog.value = false)),
                        "aria-label": "Close"
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_card_subtitle, null, {
                    default: _withCtx(() => [...(_cache[39] || (_cache[39] = [
                      _createTextVNode("Choose between credit/debit card or bank account", -1)
                    ]))]),
                    _: 1
                  }),
                  _createVNode(_component_v_card_text, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_row, { dense: "" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_col, {
                            cols: "12",
                            md: "5"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_radio_group, {
                                modelValue: currentPaymentMethodForm.value.PaymentType,
                                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((currentPaymentMethodForm.value.PaymentType) = $event)),
                                class: "mb-4",
                                "hide-details": ""
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_radio, {
                                    label: "Bank Account",
                                    value: "ACH"
                                  }),
                                  _createVNode(_component_v_radio, {
                                    label: "Credit/Debit Card",
                                    value: "CC"
                                  })
                                ]),
                                _: 1
                              }, 8, ["modelValue"]),
                              (currentPaymentMethodForm.value.PaymentType === 'CC')
                                ? (_openBlock(), _createElementBlock("p", _hoisted_14, "A convenience fee of " + _toDisplayString(convenienceFeePercentage.value) + "% is assessed for credit card payments. We only accept Visa, Mastercard or Discover.", 1))
                                : _createCommentVNode("", true)
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_v_col, {
                            cols: "12",
                            md: "6",
                            class: "align-self-end"
                          }, {
                            default: _withCtx(() => [
                              (!_unref(mobile))
                                ? (_openBlock(), _createElementBlock("h2", _hoisted_15, "Billing information"))
                                : _createCommentVNode("", true)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_row, { dense: "" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_col, {
                            cols: "12",
                            md: "5"
                          }, {
                            default: _withCtx(() => [
                              (currentPaymentMethodForm.value.PaymentType === 'CC')
                                ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                                    _createVNode(_component_v_row, { dense: "" }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_col, { cols: "12" }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_v_mask_input, {
                                              modelValue: currentPaymentMethodForm.value.CreditCardNumber,
                                              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((currentPaymentMethodForm.value.CreditCardNumber) = $event)),
                                              label: "Card Number",
                                              variant: "outlined",
                                              rules: [_unref(Rules).required, (v) => _unref(Rules).isCreditCardOfType(v, ['visa', 'mastercard', 'discover'])],
                                              mask: "#### #### #### ####",
                                              "prepend-inner-icon": "mdi-credit-card-outline"
                                            }, null, 8, ["modelValue", "rules"])
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_v_row, { dense: "" }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_col, { cols: "12" }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_v_text_field, {
                                              modelValue: currentPaymentMethodForm.value.CreditCardHolder,
                                              "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((currentPaymentMethodForm.value.CreditCardHolder) = $event)),
                                              label: "Cardholder Name",
                                              rules: [_unref(Rules).required, _unref(Rules).alpha],
                                              variant: "outlined",
                                              "prepend-inner-icon": "mdi-account"
                                            }, null, 8, ["modelValue", "rules"])
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_v_row, { dense: "" }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_col, { cols: "8" }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_v_mask_input, {
                                              modelValue: currentPaymentMethodForm.value.CreditCardExp,
                                              "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((currentPaymentMethodForm.value.CreditCardExp) = $event)),
                                              label: "Expires (MM/YY)",
                                              rules: [_unref(Rules).required, _unref(Rules).creditCardExpiry],
                                              variant: "outlined",
                                              maxlength: 5,
                                              mask: "##/##",
                                              "return-masked-value": "",
                                              "prepend-inner-icon": "mdi-calendar-range"
                                            }, null, 8, ["modelValue", "rules"])
                                          ]),
                                          _: 1
                                        }),
                                        _createVNode(_component_v_col, { cols: "4" }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_v_mask_input, {
                                              modelValue: currentPaymentMethodForm.value.CreditCardCVV,
                                              "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((currentPaymentMethodForm.value.CreditCardCVV) = $event)),
                                              label: "CVV",
                                              rules: [_unref(Rules).required, _unref(Rules).creditCardCVV],
                                              variant: "outlined",
                                              maxlength: 4,
                                              mask: "####",
                                              "prepend-inner-icon": "mdi-lock-outline",
                                              type: "password"
                                            }, null, 8, ["modelValue", "rules"])
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_v_row, { dense: "" }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_col, { cols: "12" }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_v_text_field, {
                                              modelValue: currentPaymentMethodForm.value.Nickname,
                                              "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((currentPaymentMethodForm.value.Nickname) = $event)),
                                              label: "Nickname (Optional)",
                                              placeholder: "e.g. Personal Card",
                                              maxlength: 50,
                                              variant: "outlined"
                                            }, null, 8, ["modelValue"])
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    })
                                  ]))
                                : (currentPaymentMethodForm.value.PaymentType === 'ACH')
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                                      _createVNode(_component_v_row, { dense: "" }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_col, { cols: "12" }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_v_text_field, {
                                                modelValue: currentPaymentMethodForm.value.BankRoutingNumber,
                                                "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((currentPaymentMethodForm.value.BankRoutingNumber) = $event)),
                                                label: "Routing Number",
                                                variant: "outlined",
                                                density: "comfortable",
                                                maxlength: "9",
                                                rules: [_unref(Rules).required, _unref(Rules).bankRoutingNumberValid]
                                              }, null, 8, ["modelValue", "rules"])
                                            ]),
                                            _: 1
                                          })
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_v_row, { dense: "" }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_col, { cols: "12" }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_v_text_field, {
                                                modelValue: currentPaymentMethodForm.value.BankAccountNumber,
                                                "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((currentPaymentMethodForm.value.BankAccountNumber) = $event)),
                                                label: "Account Number",
                                                variant: "outlined",
                                                density: "comfortable",
                                                maxlength: "17",
                                                rules: [_unref(Rules).required]
                                              }, null, 8, ["modelValue", "rules"])
                                            ]),
                                            _: 1
                                          })
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_v_row, { dense: "" }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_col, { cols: "12" }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_v_text_field, {
                                                label: "Confirm Account Number",
                                                variant: "outlined",
                                                maxlength: "17",
                                                rules: [_unref(Rules).required, (v) => confirmBankAccount(v, currentPaymentMethodForm.value.BankAccountNumber)],
                                                density: "comfortable"
                                              }, null, 8, ["rules"])
                                            ]),
                                            _: 1
                                          })
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_v_row, { dense: "" }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_col, { cols: "12" }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_v_text_field, {
                                                modelValue: currentPaymentMethodForm.value.Nickname,
                                                "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((currentPaymentMethodForm.value.Nickname) = $event)),
                                                label: "Nickname (Optional)",
                                                placeholder: "e.g. Personal Card",
                                                maxlength: 50,
                                                variant: "outlined"
                                              }, null, 8, ["modelValue"])
                                            ]),
                                            _: 1
                                          })
                                        ]),
                                        _: 1
                                      })
                                    ]))
                                  : _createCommentVNode("", true)
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_v_divider, {
                            vertical: "",
                            thickness: 2,
                            class: "mx-4"
                          }),
                          _createVNode(_component_v_col, {
                            cols: "12",
                            md: "6"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_row, { dense: "" }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_col, { cols: "12" }, {
                                    default: _withCtx(() => [
                                      (_unref(mobile))
                                        ? (_openBlock(), _createElementBlock("h2", _hoisted_18, "Billing information"))
                                        : _createCommentVNode("", true)
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_v_row, { dense: "" }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_col, {
                                    cols: "12",
                                    sm: "6"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_text_field, {
                                        modelValue: currentPaymentMethodForm.value.FirstName,
                                        "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((currentPaymentMethodForm.value.FirstName) = $event)),
                                        label: "First Name",
                                        variant: "outlined",
                                        density: "comfortable",
                                        maxlength: "50",
                                        rules: [_unref(Rules).required]
                                      }, null, 8, ["modelValue", "rules"])
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_v_col, {
                                    cols: "12",
                                    sm: "6"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_text_field, {
                                        modelValue: currentPaymentMethodForm.value.LastName,
                                        "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((currentPaymentMethodForm.value.LastName) = $event)),
                                        label: "Last Name",
                                        variant: "outlined",
                                        density: "comfortable",
                                        maxlength: "50",
                                        rules: [_unref(Rules).required]
                                      }, null, 8, ["modelValue", "rules"])
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_v_row, { dense: "" }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_col, { cols: "12" }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_text_field, {
                                        modelValue: currentPaymentMethodForm.value.StreetAddress,
                                        "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((currentPaymentMethodForm.value.StreetAddress) = $event)),
                                        label: "Address",
                                        variant: "outlined",
                                        density: "comfortable",
                                        maxlength: "50",
                                        rules: [_unref(Rules).required]
                                      }, null, 8, ["modelValue", "rules"])
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_v_row, { dense: "" }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_col, {
                                    cols: "12",
                                    sm: "6"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_text_field, {
                                        modelValue: currentPaymentMethodForm.value.City,
                                        "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((currentPaymentMethodForm.value.City) = $event)),
                                        label: "City",
                                        variant: "outlined",
                                        density: "comfortable",
                                        rules: [_unref(Rules).required],
                                        maxlength: "50"
                                      }, null, 8, ["modelValue", "rules"])
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_v_col, {
                                    cols: "12",
                                    sm: "6"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_select, {
                                        items: _unref(states),
                                        "item-title": "abbreviation",
                                        "item-value": "abbreviation",
                                        label: "State",
                                        modelValue: currentPaymentMethodForm.value.State,
                                        "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((currentPaymentMethodForm.value.State) = $event)),
                                        rules: [_unref(Rules).required],
                                        variant: "outlined",
                                        density: "comfortable"
                                      }, null, 8, ["items", "modelValue", "rules"])
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_v_row, { dense: "" }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_col, {
                                    cols: "12",
                                    sm: "6"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_mask_input, {
                                        modelValue: currentPaymentMethodForm.value.Zip,
                                        "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((currentPaymentMethodForm.value.Zip) = $event)),
                                        label: "ZIP Code",
                                        mask: "#####",
                                        variant: "outlined",
                                        density: "comfortable",
                                        rules: [_unref(Rules).required],
                                        maxlength: "5"
                                      }, null, 8, ["modelValue", "rules"])
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_card_actions, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_btn, {
                        color: "#030213",
                        variant: "elevated",
                        block: "",
                        onClick: addPaymentMethod
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(isPaymentFormDialogEdit.value ? 'Update Payment Method' : 'Add Payment Method'), 1)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["modelValue"])
    ]),
    _: 1
  }))
}
}

})